import { render } from "./ServiceCategoryPage.vue?vue&type=template&id=346346d6"
import script from "./ServiceCategoryPage.vue?vue&type=script&lang=js"
export * from "./ServiceCategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__